// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8e9a857e","137":"b71a3da9","166":"53452d19","406":"f3bfac86","453":"8379da6e","459":"991353c6","509":"2f5729ce","599":"980ae726","768":"2b7bc720","814":"4ce19c8e","864":"e981d481","990":"753c66b5"}[chunkId] + ".chunk.js";
};